import React from "react";
import Hero from "@/components/vlyt/Hero";
import Marquee from "@/components/vlyt/Marquee";
import FounderStory from "@/components/vlyt/FounderStory";
import TheFriction from "@/components/vlyt/TheFriction";
import TheHandshake from "@/components/vlyt/TheHandshake";
import TheRoyalty from "@/components/vlyt/TheRoyalty";
import StatsStrip from "@/components/vlyt/StatsStrip";
import FeaturesGrid from "@/components/vlyt/FeaturesGrid";
import WaitlistModal from "@/components/vlyt/WaitlistModal";
import Seo from "@/components/vlyt/Seo";

export default function Home() {
  const [wlOpen, setWlOpen] = React.useState(false);
  const openWl = () => setWlOpen(true);
  return (
    <>
      <Seo canonical="https://govlyt.com/" />
      <Hero onOpenWaitlist={openWl} />
      <Marquee />
      <FounderStory />
      <TheFriction />
      <TheHandshake />
      <StatsStrip />
      <FeaturesGrid />
      <TheRoyalty onOpenWaitlist={openWl} />
      <WaitlistModal open={wlOpen} onOpenChange={setWlOpen} source="home" />
    </>
  );
}
